// CSV helpers shared by the bulk uploads (Products, booking-group student
// details). No dependency — the parser handles quoted fields with embedded
// commas, newlines and doubled quotes, and CRLF line ends.

// Marks a template's example row so it can never be imported by accident.
export const CSV_SENTINEL_HEADER = "template_row_id";
export const CSV_SENTINEL_VALUE = "EXAMPLE_DO_NOT_IMPORT";

export function parseCsv(text) {
  const rows = [];
  let row = [];
  let cur = "";
  let inQuotes = false;

  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    const next = text[i + 1];

    if (ch === '"') {
      if (inQuotes && next === '"') {
        // escaped quote
        cur += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }

    if (!inQuotes && ch === ",") {
      row.push(cur);
      cur = "";
      continue;
    }

    if (!inQuotes && (ch === "\n" || ch === "\r")) {
      // handle CRLF
      if (ch === "\r" && next === "\n") i++;
      row.push(cur);
      cur = "";
      // ignore fully empty trailing line
      if (row.some((c) => String(c || "").trim() !== "")) rows.push(row);
      row = [];
      continue;
    }

    cur += ch;
  }

  // last cell
  row.push(cur);
  if (row.some((c) => String(c || "").trim() !== "")) rows.push(row);

  return rows;
}

export const normalizeHeader = (h) => String(h || "").trim().toLowerCase();

// One CSV line from an ordered list of values, every cell quoted.
export const csvLine = (values) =>
  values.map((v) => `"${String(v ?? "").replaceAll('"', '""')}"`).join(",");

export function downloadCsv(filename, content) {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
